import { topicsData } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            发现当下最受关注的影视话题，找到属于你的观影灵感
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicsData.map((topic, idx) => (
            <a
              key={idx}
              href="#cards"
              className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer no-underline ${
                topic.hot
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-background-100 text-foreground-700 hover:bg-background-200'
              }`}
            >
              {topic.hot && <i className="ri-fire-line text-xs"></i>}
              {topic.name}
              <span className={`text-xs ${topic.hot ? 'text-background-200' : 'text-foreground-400'}`}>
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}